import React, { useRef } from 'react';
import { ChevronDown, ChevronUp, Search, X } from 'lucide-react';

export function PdfSearchBar({
  query,
  onQueryChange,
  matchCount,
  activeIndex,
  onPrev,
  onNext,
  onClose,
}: {
  query: string;
  onQueryChange: (q: string) => void;
  matchCount: number;
  activeIndex: number;
  onPrev: () => void;
  onNext: () => void;
  onClose: () => void;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const label = query.trim()
    ? matchCount === 0
      ? '0 matches'
      : `${activeIndex + 1} / ${matchCount}`
    : '';

  return (
    <div className="pdf-search-bar" role="search">
      <Search size={14} aria-hidden />
      <input
        ref={inputRef}
        type="search"
        className="pdf-search-input"
        placeholder="Find in document"
        value={query}
        onChange={e => onQueryChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (e.shiftKey) onPrev();
            else onNext();
          }
          if (e.key === 'Escape') {
            e.preventDefault();
            onClose();
          }
        }}
        aria-label="Find in document"
      />
      <span className="pdf-search-count">{label}</span>
      <button type="button" onClick={onPrev} disabled={matchCount === 0} aria-label="Previous match">
        <ChevronUp size={14} />
      </button>
      <button type="button" onClick={onNext} disabled={matchCount === 0} aria-label="Next match">
        <ChevronDown size={14} />
      </button>
      <button type="button" onClick={onClose} aria-label="Close search">
        <X size={14} />
      </button>
    </div>
  );
}
